<template>
    <v-app-bar color="navigation">
        <v-app-bar-nav-icon v-if="sidebar" variant="text" @click="emit_sidebar"></v-app-bar-nav-icon>
        <img v-if="logo != undefined" :src="logo" style="width:36px;height:36px;margin-left:8px;" />
        <v-toolbar-title>
            <slot name="title"></slot>
        </v-toolbar-title>
        <template v-slot:append>
            <v-text-field v-if="authorized && search_box && (is_search_focused || search)" clearable ref="search_box" class="search"
                density="compact" variant="solo" :label="$tr('Поиск')" 
                :prepend-inner-icon="query?.processing ? 'mdi mdi-magnify-scan' : 'mdi mdi-magnify'"
                @update:focused="search_focused" single-line hide-details v-model="query_mode.value">
            </v-text-field>
            <div v-if="authorized" class="d-flex">
                <tool-button v-if="search_box && (!is_search_focused && !search)" icon="magnify"
                    :onclick="search_click">
                </tool-button>
            </div>
            <v-menu v-if="!hide_header_controls && infos != undefined && infos.length > 0" anchor="start">
                <template v-slot:activator="{ props }">
                    <v-btn variant="text" icon="mdi-information" v-bind="props"></v-btn>
                </template>
                <v-list>
                    <v-list-item v-for="(item, index) in infos" :key="index" :value="index" @click="item.on_click">
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <toggle-switch v-if="!xs && !hide_header_controls" @click="switch_theme" />
            <v-menu v-if="lang != undefined && !xs && Object.keys(locales).length > 1 && !hide_header_controls">
                <template v-slot:activator="{ props }">
                    <v-btn icon v-bind="props">
                        <img :src="locales[lang].icon" width="24">
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item v-for="lang in Object.keys(locales)" :key="lang" :value="lang"
                        @click="switch_lang(lang)">
                        <template v-slot:prepend>
                            <img :src="locales[lang].icon" width="24" style="padding-right:8px;">
                        </template>
                        <v-list-item-title>{{ locales[lang].name }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-menu v-if="!hide_header_controls" anchor="start">
                <template v-slot:activator="{ props }">
                    <v-btn variant="text" icon="mdi-apps" v-bind="props"></v-btn>
                </template>
                <v-list>
                    <v-list-item v-for="(item, index) in apps" :key="index" :value="index" @click="navigate(item.uri)">
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-menu v-if="!hide_header_controls" anchor="start">
                <template v-slot:activator="{ props }">
                    <v-btn v-if="authorized" icon v-bind="props">
                        <avatar-view :user="$api.me.user" :size="40" class="mx-0"></avatar-view>
                    </v-btn>
                    <v-btn v-else color="success" @click="login">
                        {{ $tr("Войти") }}
                    </v-btn>
                </template>
                <v-list>
                    <user-detail :user="me" style="padding-left:10px;padding-right:10px;" />
                    <v-menu v-if="lang != undefined && xs && Object.keys(locales).length > 1">
                        <template v-slot:activator="{ props }">
                            <v-list-item v-bind="props">
                                <v-list-item-title>{{ $tr('Язык') }}</v-list-item-title>
                                <template v-slot:append>
                                    <v-list-item>
                                        <template v-slot:prepend>
                                            <img :src="locale.icon" width="24" style="padding-right:8px;">
                                        </template>
                                        <v-list-item-title>{{ locale.name }}</v-list-item-title>
                                    </v-list-item>
                                </template>
                            </v-list-item>
                        </template>
                        <v-list>
                            <v-list-item v-for="lang in Object.keys(locales)" :key="lang" :value="lang"
                                @click="switch_lang(lang)">
                                <template v-slot:prepend>
                                    <img :src="locales[lang].icon" width="24" style="padding-right:8px;">
                                </template>
                                <v-list-item-title>{{ locales[lang].name }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-list-item v-if="xs" @click="switch_theme">
                        <v-list-item-title>{{ $tr('Тема') }}</v-list-item-title>
                        <template v-slot:append>
                            <toggle-switch></toggle-switch>
                        </template>
                    </v-list-item>

                    <v-divider></v-divider>
                    <v-list-item v-if="settings != null" @click="settings">
                        <template v-slot:prepend>
                            <tool-icon name="cog-outline" />
                        </template>
                        <v-list-item-title>{{ $tr('Настройки') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logout">
                        <template v-slot:prepend>
                            <tool-icon name="logout" />
                        </template>
                        <v-list-item-title>{{ $tr('Выйти') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$api.multiaccount" @click="login">
                        <template v-slot:prepend>
                            <tool-icon name="account-plus" />
                        </template>
                        <v-list-item-title>{{ $tr('Добавить пользователя') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$api.multiaccount" @click="switch_account">
                        <template v-slot:prepend>
                            <tool-icon name="account-switch" />
                        </template>
                        <v-list-item-title>{{ $tr('Сменить пользователя') }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </template>
    </v-app-bar>
</template>

<script>
import {
    localization,
} from '../l10n';
import ToggleSwitch from './ToggleSwitch.vue';
import UserDetail from './UserDetail.vue';
import ToolIcon from './ToolIcon.vue';
import AvatarView from './AvatarView.vue';
import ToolButton from './ToolButton.vue';

export default {
    components: {
        ToggleSwitch,
        ToolIcon,
        UserDetail,
        AvatarView,
        ToolButton,
    },
    props: {
        logo: String,
        sidebar: {
            type: Boolean,
            default: false,
        },
        query: {
            type: Object,
            default: undefined,
        },
        settings: Function,
        infos: Array,
    },
    data() {
        return {
            is_search_focused: false,
            query_mode: this.query,
        };
    },
    emits: ['sidebar'],
    computed: {
        query_changes() {
            return this.query_mode === this.query;
        },
        authorized() {
            return this.$api.authorized;
        },
        me() {
            const me = this.$api.me;
            if (me == null) {
                return undefined;
            }
            return me.user;
        },
        fullname() {
            const me = this.me;
            if (me == null) {
                return undefined;
            }
            const name = me.name;
            const surname = me.surname;
            if (name == null) {
                if (surname == null) {
                    return me.email || me.uid;
                }
                return name;
            }
            if (surname == null) {
                return name;
            }
            return `${name} ${surname}`;
        },
        lang() {
            return localization.lang();
        },
        locales() {
            return localization.locales();
        },
        locale() {
            return this.locales[this.lang];
        },
        display() {
            return this.$vuetify.display;
        },
        xs() {
            return this.display.xs;
        },
        apps() {
            return [
                { uri: 'https://id.topomatic.ru', title: this.$tr('Topomatic ID') },
                { uri: 'https://licences.topomatic.ru', title: this.$tr('Менеджер лицензий') },
                { uri: 'https://cloud.topomatic.ru', title: this.$tr('Облачное хранилище') },
                { uri: 'https://support.topomatic.ru', title: this.$tr('Техническая поддержка') },
                { uri: 'https://topomatic.ru/forums', title: this.$tr('Форум') },
            ];
        },
        search() {
            return this.query?.value;
        },
        search_box() {
            return this.query != null;
        },
        hide_header_controls() {
            return this.display.smAndDown && this.search_box && (this.is_search_focused || this.search);
        },
    },
    methods: {
        navigate(uri) {
            window.location = uri;
        },
        login() {
            this.$router.push({ view: 'login' });
        },
        logout() {
            this.$api.logout(this.$api.me);
        },
        switch_lang(lang) {
            localization.activate(lang);
        },
        switch_theme() {
            const theme = this.$router.theme;
            if (theme === 'dark') {
                this.$router.theme = 'light';
            } else {
                this.$router.theme = 'dark';
            }
        },
        switch_account() {
            const payload = this.$router.payload;
            const redirect_uri = this.$router.href(payload);
            this.$router.push({
                view: 'login',
                mode: 'switch',
                redirect_uri,
            });
        },
        emit_sidebar() {
            this.$emit('sidebar');
        },
        search_focused(value) {
            this.is_search_focused = value;
        },
        search_click() {
            this.search_focused(this);
            this.$nextTick(() => {
                if (this.search_box) {
                    const el = this.$refs.search_box;
                    if (el != null) {
                        el.focus();
                        el.select();
                        if (el.setSelectionRange != null) {
                            el.setSelectionRange(0, el.value.length);
                        }
                    }
                }
            });
        },
    },
    watch: {
        query_changes() {
            if (this.query_mode === undefined && this.query !== undefined) {
                this.query_mode = this.query;
            }
        },
    },
};
</script>

<style scoped>
.search {
    width: 400px;
    max-width: 50vw !important;
    margin-left: 16px;
    margin-right: 16px;
}
</style>
